export type EraajoProjekti = 'lemonator' | 'lemonaid'

/** Status-dokumentti Firestoressa kokoelmassa `eraajot-status`. Dokumentin id on pubsub-topicin nimi. */
export interface EraajoStatusFirestore {
  /** = pubsub-topic, samalla Firestore-dokumentin id. */
  topic: string
  projekti: EraajoProjekti
  lastSucceeded: { toMillis(): number; toDate(): Date } | null
  lastFailed: { toMillis(): number; toDate(): Date } | null
  lastError?: string
}

export type Liikennevalo = 'vihrea' | 'keltainen' | 'punainen' | 'tuntematon' | 'pausettu'

export function liikennevaloSevereetti(valo: Liikennevalo): number {
  switch (valo) {
    case 'punainen':
      return 0
    case 'keltainen':
      return 1
    case 'pausettu':
      return 2
    case 'tuntematon':
      return 3
    case 'vihrea':
      return 4
  }
}

export interface EraajotStatusHaeReq {}

export interface EraajotStatusHaeRespRivi {
  /** Pubsub-topic — liitosavain status-dokumentin id:hen */
  topic: string
  projekti: EraajoProjekti
  selite: string
  valo: Liikennevalo
  /** Ihmisystävällinen selite valon väriin (esim. "Ajo juuri myöhässä"). */
  valoSelite: string
  /** Raw cron-lauseke Cloud Schedulerista. Aina läsnä, myös kun parse epäonnistui. */
  schedule: string
  /** Aikavyöhyke Cloud Schedulerista. */
  aikavyohyke: string
  /** ISO-aikaleima seuraavalle odotetulle ajolle. null jos cron-laskenta epäonnistui. */
  seuraavaOdotettuAjoIso: string | null
  /** ISO-aikaleima edelliselle odotetulle ajolle. null jos cron-laskenta epäonnistui. */
  edellinenOdotettuAjoIso: string | null
  lastSucceededIso: string | null
  lastFailedIso: string | null
  lastError?: string
  /** True jos eraajot-status -dokumentti löytyy Firestoresta (= handleria on ainakin kerran ajettu). */
  onkoStatusDokumentti: boolean
  /** Kuinka monta Cloud Scheduler -jobia julkaisee tähän topiciin. Policy = 1; > 1 = duplikaatti, näytetään varoitus dashboardissa. */
  topicJobMaara: number
}

/**
 * Orpo: status-dokumentti Firestoressa jolla EI ole vastaavaa Cloud Scheduler -työtä.
 * Yleisin syy: Scheduler-job on poistettu tai uudelleennimetty, mutta handler ajoi vielä viimeksi
 * vanhalle topicille.
 */
export interface EraajotStatusHaeOrpo {
  projekti: EraajoProjekti
  topic: string
  lastSucceededIso: string | null
  lastFailedIso: string | null
}

export interface EraajotStatusHaeResp {
  tilat: EraajotStatusHaeRespRivi[]
  orvot: EraajotStatusHaeOrpo[]
  haettuIso: string
  /** Virheviesti jos callablen suoritus epäonnistui osittain. */
  e?: string
}
